





























import { Component } from 'vue-property-decorator'
import CardPanel from '@/components/common/CardPanel.vue'
import RouterHelper from '@/mixins/RouterHelper.vue'
import OperationResultTips from '@/components/common/OperationResultTips.vue'

@Component({
  components: {
    CardPanel,
    OperationResultTips
  }
})
export default class MailValidateSuccess extends RouterHelper {
  private tipsType: string = 'validateSuccess'

  private gotoLogin () {
    const loginRoute = this.getCompleteRouteByPathObject({
      name: 'login'
    })
    this.$router.push(loginRoute)
  }

  mounted () {
    const typesMap: { [key: string]: string } = { '0': 'validate', '2': 'warning' }
    // @ts-ignore
    this.tipsType = typesMap[this.$route.query.status || '0'] || 'validate'
  }
}
